export default __webpack_public_path__ + "static/media/banner.c838abcb.png";